import axios from 'axios';

export default {
    getRMAs(page, sorting, filter) {
        return axios.get('/api/dashboard/rmas',
            {
                params: {
                    page: page,
                    sortBy: sorting.sortBy,
                    sortOrder: sorting.sortOrder
                }
            });
    },
    getRmaList(page, text, sorting) {
        return axios.get('/api/rma/table',
            {
                params: {
                    page: page,
                    rmaNumber: text,
                    sortBy: sorting.sortBy,
                    sortOrder: sorting.sortOrder
                }
            });
    },
    deleteRma(id) {
        return axios.delete(`/api/rma/${id}`);
    },
    getRma(id) {
        return axios.get(`/api/rma/${id}`);
    },
    getRmaNumber() {
        return axios.get('/api/rma/getRmaNumber');
    },
    printRma(id) {
        return axios.get(`/api/rma/${id}/print`);
    },
    saveRma(form) {
        var data = {
            attnId: form.attn,
            serviceTicket: { ...form.serviceTicket, rmaId: form.rmaNumber, raisedOn: form.serviceTicket.raisedOn },
            serviceCompany: { ...form.serviceCompany },
            serviceTicketId: form.serviceTicketId,
            serviceCompanyId: form.serviceCompanyId,
            claimId: form.claimId,
            shippingMethod: form.shippingMethod,
            countryOfOrigin: form.countryOfOrigin,
            serviceTicketNumber: form.serviceTicketNumber,
            invoiceNumber: form.invoiceNumber,
            claimNumber: form.claimNumber,
            id: form.rmaNumber,
            attns: [],
            claimStatus: form.claimStatus,
            rmaDate: form.rmaDate,
            customer: form.selectedCustomer,
            status: form.status,
            trackingNumber: form.trackingNumber,
            comment: form.comment,
            reason: form.reason
        };

        return axios.post(`/api/rma/saveRma`, data);
    },
    async getTrackingInfo(trackNumber) {
        var result = await axios.post('/api/rma/getTrackingInfo', { trackNumber });
    return result;
    }
};


// WEBPACK FOOTER //
// ./ClientApp/app/rma/api.js